.Main {
    padding: var(--small-space) 0 0 0;
}

.Item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1.7;
    padding: 0.5em 1em;
    border-radius: 2em;
    margin: 0 0 var(--small-space) 0;
    border: solid 2px currentColor;
    text-transform: capitalize;
    text-decoration: none;
    white-space: nowrap;
}

.Item span {
    overflow: hidden;
    text-overflow: ellipsis;
}

.Item svg {
    width: 26px;
    height: 27px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2px;
    margin: 0 0 0 1em;
}